import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useUserData } from "lib/store/user";
import type { OnboardingFormattedRes } from "lib/types/onboarding";
import ZephrFeature from "components/zephr";
import { ZEPHR_FEATURES } from "lib/zephr/constants";

const OnboardingModal = dynamic(
  () => import("components/onboarding/onboardingModal"),
  { ssr: false }
);

const OnboardingDialog = () => {
  const [onboardingData, setOnboardingData] =
    useState<OnboardingFormattedRes | null>(null);
  const [onboardingType, setOnboardingType] = useState<string | null>(null);

  const {
    userProfile: { first_name },
  } = useUserData();

  useEffect(() => {
    async function checkForOnboardingTrigger() {
      const triggerElement = document.querySelector(
        '[data-show-onboarding="true"]'
      );

      if (triggerElement) {
        const type = triggerElement.getAttribute("data-onboarding-type");

        if (type) {
          try {
            const data: OnboardingFormattedRes = await fetch(
              "/api/onboarding"
            ).then((res) => res.json());

            if (data[type]) {
              setOnboardingType(type);
              setOnboardingData(data);
            } else {
              // eslint-disable-next-line no-console
              console.error(
                `Onboarding type "${type}" not found in data. Available types: ${Object.keys(data).join(", ")}`
              );
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Failed to fetch onboarding data", error);
          }
        } else {
          // eslint-disable-next-line no-console
          console.error(
            "Onboarding trigger element found but no data-onboarding-type attribute"
          );
        }
      }
    }

    checkForOnboardingTrigger();
  }, []);

  return (
    <>
      <ZephrFeature name={ZEPHR_FEATURES.ONBOARDING_SHOW_MODAL} />
      {onboardingData && onboardingType ? (
        <OnboardingModal
          givenName={first_name}
          onboardingType={onboardingType}
          data={onboardingData}
        />
      ) : null}
    </>
  );
};

export default OnboardingDialog;
